class GiftBag extends HTMLElement {
  constructor() {
    super();

    this.giftBagId = this.dataset.giftBagId;
    this.miniCart  = document.querySelector('mini-cart');
    this.checkbox  = this.querySelector('[type="checkbox"]');

    // 🔑  pega a chave do atributo (gift-bag, gift-bag-02, gift-bag-03…)
    this.attrKey   = this.checkbox.name.match(/\[([^\]]+)\]/)[1];

    this.checkbox.addEventListener('change', (e) => {
      e.target.checked ? this.addGiftBag() : this.removeGiftBag();
    });
  }

  addGiftBag()  { this.updateCart(1, 'yes'); }
  removeGiftBag(){ this.updateCart(0,  '' ); }

  updateCart(qty, attrVal){
    this.toggleLoading(true);

    const body = JSON.stringify({
      updates: { [this.giftBagId]: qty },
      attributes: { [this.attrKey]: attrVal },
      sections: this.getSectionsToRender().map(s => s.section),
      sections_url: window.location.pathname
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type':'application/json' },
      body
    })
    .then(r => { if(!r.ok) throw Error('Erro'); return r.json(); })
    .then(r => {
      this.toggleLoading(false);
      this.miniCart && this.miniCart.renderContents(r);
      this.checkbox.checked = !!attrVal;
    })
    .catch(_=>{
      this.toggleLoading(false);
      this.checkbox.checked = !attrVal;
    });
  }

  toggleLoading(state){
    this.querySelector('.loading-overlay').classList.toggle('hidden', !state);
  }

  getSectionsToRender(){
    return [
      { id:'mini-cart',       section:'mini-cart',       selector:'.shopify-section' },
      { id:'cart-icon-bubble',section:'cart-icon-bubble',selector:'.shopify-section' }
    ];
  }
}

customElements.define('gift-bag', GiftBag);
